import { Dialog, DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, TemplateRef, inject } from '@angular/core';

const DEFAULT_CONFIG = {
  hasBackdrop: true,
  backdropClass: 'modal-backdrop',
  panelClass: 'modal-panel',
  disableClose: true,
};

@Injectable({ providedIn: 'root' })
export class ModalService {
  private dialog = inject(Dialog);

  constructor() {
    this.dialog.afterOpened.subscribe(() => this.toggleBackgroundBlur(true));
    this.dialog.afterAllClosed.subscribe(() => this.toggleBackgroundBlur(false));
  }

  openDialog<C, CloseType = unknown>(
    component: ComponentType<C> | TemplateRef<C>,
    param?: unknown,
    data?: DialogConfig<unknown, DialogRef<CloseType, C>>,
  ) {
    return this.dialog.open(component, { ...DEFAULT_CONFIG, ...data, data: param });
  }

  isOpen() {
    return !!this.dialog;
  }

  private toggleBackgroundBlur(blur: boolean) {
    document.getElementsByClassName('app-wrapper')?.[0]?.classList.toggle('blur', blur);
  }
}
